import React from 'react';
import PersonCards from '../components/PersonCards';
import "../App.css";
import ProjectCards from '../components/ProjectCards';

const Dashboard = () => {
  return (
    <div className="dashboard-container p-2">
      <div className="section">
        <ProjectCards />
      </div>
      <div className="section">
        <PersonCards />
      </div>
    </div>
  );
}

export default Dashboard;
  